import React from 'react';
import { Container, Row} from 'react-bootstrap';
import FaqCard from './FaqCard';

import TitleIcon1 from '../../assets/img/title-icon.png';

const questions = [
    {
        no: "01",
        title: "請問怎麼報名本次活動呢？",
        ans: "一律網路報名：採伊貝特線上報名，報名時間為2026/2/6（五）12:00至2026/8/15（六），現已截止。報名連結：https://bao-ming.com/eb/content/6882#32494",
    },
    {
        no: "02",
        title: "我報名後要如何繳費呢？有繳費期限嗎？",
        ans: "報名後可至三大超商繳費、線上刷卡，請於72小時內完成繳費，逾時未繳費系統將自動取消報名訂單。",
    },
    {
        no: "03",
        title: "報名後因為有事無法參加怎麼辦？",
        ans: "本活動退費機制如下：①2026/8/15（六）報名截止前申請，每人酌收報名費100元手續費後退還，請洽伊貝特客服專區辦理（週一至週五10:00～18:00）。②8/16～9/15申請，退還報名費30%，請洽伊貝特客服專區辦理。③9/16起因所有作業已完成，如需申請退費，請洽官方LINE（https://lin.ee/PWu064q ）。④統一於10/20起開始辦理退費作業。",
    },
    {
        no: "04",
        title: "如果報名之後發現輸入的資料有誤，可以修改嗎？",
        ans: "未繳交報名費：可至報名系統內報名查詢，自行更正選手資料、組別或車衣尺寸。已繳交報名費：請洽伊貝特客服（週一至週五10:00～18:00）。請審慎填寫報名資料。",
    },
    {
        no: "05",
        title: "若訂單顯示逾期怎麼辦？",
        ans: "可至報名系統內報名查詢，自行延長訂單。或來電02-2727-1786分機1913、0981-336-402由專人協助（週一至週五10:00～18:00）。報名截止後，恕不延長訂單。",
    },
    {
        no: "06",
        title: "若報名繳費後要再新增選手合併訂單怎麼辦？",
        ans: "請新增之選手先進行報名程序，先不繳費，並來電告知已繳費跟未繳費的訂單編號，專人會替您告知系統處理，並會再通知選手補繳差額。",
    },
    {
        no: "07",
        title: "需要開立收據如何申請？",
        ans: "如需開立收據，請洽官方LINE（https://lin.ee/PWu064q ）申請。",
    },
    {
        no: "08",
        title: "怎麼申請退費呢？",
        ans: "本活動退費機制如下：①2026/8/15（六）報名截止前申請，每人酌收報名費100元手續費後退還，請洽伊貝特客服專區辦理（週一至週五10:00～18:00）。②8/16～9/15申請，退還報名費30%，請洽伊貝特客服專區辦理。③9/16起因所有作業已完成，如需申請退費，請洽官方LINE（https://lin.ee/PWu064q ）。④統一於10/20起開始辦理退費作業。",
    },
]

const questionsEng = [
    {
        no: "01",
        title: "How do I register for L'Étape Sun Moon Lake?",
        ans: "Registration is online only, via the Ebet online registration platform. Registration ran from February 6, 2026 (Fri), 12:00 to August 15, 2026 (Sat) and is now closed. Registration page: https://bao-ming.com/eb/content/6882#32494",
    },
    {
        no: "02",
        title: "How do I pay after registering? Is there a payment deadline?",
        ans: "After registering, you can pay at any of the three major convenience store chains or online by credit card. Please complete payment within 72 hours; unpaid orders will be automatically canceled by the system after that.",
    },
    {
        no: "03",
        title: "What if I can't take part after registering?",
        ans: "Refund policy: (1) Requests made before the registration deadline of August 15, 2026 (Sat): refunded minus a NT$100 handling fee per person; apply through Ebet customer service (Monday to Friday, 10:00 AM - 6:00 PM). (2) Requests made from August 16 to September 15: 30% of the entry fee will be refunded; apply through Ebet customer service. (3) From September 16, all preparations are complete; for any refund request, please contact our official LINE account (https://lin.ee/PWu064q). (4) Refunds will be processed starting October 20.",
    },
    {
        no: "04",
        title: "Can I correct my details if I find a mistake after registering?",
        ans: "If you have not yet paid the entry fee, you can look up your registration in the registration system and correct your details, category, or jersey size yourself. If you have already paid, please contact Ebet customer service (Monday to Friday, 10:00 AM - 6:00 PM). Please fill in your registration details carefully.",
    },
    {
        no: "05",
        title: "What should I do if my order shows as expired?",
        ans: "You can look up your registration in the registration system and extend the order yourself, or call 02-2727-1786 ext. 1913 or 0981-336-402 for assistance (Monday to Friday, 10:00 AM - 6:00 PM). Orders cannot be extended after registration closes.",
    },
    {
        no: "06",
        title: "I've already registered and paid. How do I add another participant to my order?",
        ans: "Have the new participant register first without paying. Then call us with the order numbers of both the paid and unpaid orders. Our staff will have the orders combined in the system and will let the participant know the balance to pay.",
    },
    {
        no: "07",
        title: "How do I request a receipt?",
        ans: "To request a receipt, please contact our official LINE account (https://lin.ee/PWu064q).",
    },
    {
        no: "08",
        title: "How do I request a refund?",
        ans: "Refund policy: (1) Requests made before the registration deadline of August 15, 2026 (Sat): refunded minus a NT$100 handling fee per person; apply through Ebet customer service (Monday to Friday, 10:00 AM - 6:00 PM). (2) Requests made from August 16 to September 15: 30% of the entry fee will be refunded; apply through Ebet customer service. (3) From September 16, all preparations are complete; for any refund request, please contact our official LINE account (https://lin.ee/PWu064q). (4) Refunds will be processed starting October 20.",
    },
]

const SignUpQ = ({language}) => {
    return (
        <section className="faq-signup">
            <Container>
                <Row className='align-items-center faq-section'>
                    <h2 className='faq-header'><span><img className='faq-icon' src={TitleIcon1} alt="" /></span>{language === "Chinese" ? "報名與繳費相關" : "Registration and Payment"}</h2>
                    {language === "Chinese" ? 
                        questions.map((q, index) => (
                            <FaqCard
                                key={index}
                                {...q}
                            />
                        ))
                    : 
                        questionsEng.map((q, index) => (
                            <FaqCard
                                key={index}
                                {...q}
                            />
                        ))
                    }
                </Row>
            </Container>
        </section>
    )
}

export default SignUpQ